export default "__VITE_ASSET__DG8pf0z2__"